// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, number, object, oneOfType, string } from 'prop-types'
import { UpdatedLabeledTextAreaWrapper } from './styles'

import {
  ErrorSimple,
  LabelSimple,
} from 'components/Form'

class UpdatedLabeledTextarea extends React.Component {
  static propTypes = {
    autoFocus: bool,
    className: string,
    disabled: bool,
    id: string.isRequired,
    input: object.isRequired,
    label: oneOfType([
      string,
      object,
    ]),
    meta: object.isRequired,
    placeholder: string,
    rows: number,
  }

  static defaultProps = {
    className: '',
  }

  render () {
    const {
      autoFocus,
      className,
      disabled,
      id,
      input,
      label,
      meta,
      placeholder,
      rows,
    } = this.props

    return (
      <UpdatedLabeledTextAreaWrapper
        className={`updated-labeled-text-area ${className}`}
        title={input.value}>
        <LabelSimple
          idRoot={id}
          label={label} />
        <textarea
          {...input}
          autoFocus={autoFocus}
          className={'input'}
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          rows={rows} />
        <ErrorSimple
          error={meta.error}
          idRoot={id} />
      </UpdatedLabeledTextAreaWrapper>
    )
  }
}

export default UpdatedLabeledTextarea
